// The backoffice shows players as `PLAYER-<uuid>`; middleware accepts that form and strips the
// prefix itself. The same pattern middleware validates with, so the form refuses what the API would.
export const PLAYER_ID_PATTERN = /^PLAYER-[A-Za-z0-9][A-Za-z0-9-]*$/;

export const PLAYER_ID_EXAMPLE = 'PLAYER-8d2d3f8e-7f7f-4c1e-9b0e-2a3b4c5d6e7f';

export function isPlayerId(value: string): boolean {
  return PLAYER_ID_PATTERN.test(value.trim());
}

// Reports store the bare lowercase uuid; agents recognise the backoffice form.
export function toPlayerId(uuid: string): string {
  return `PLAYER-${uuid}`;
}
